import { Col, Row, Avatar, Dropdown, Space, Menu, Typography, Button } from "antd";
import { Header } from "antd/es/layout/layout";
import { CiLogout } from "react-icons/ci";
import { MenuOutlined } from "@ant-design/icons";

import './style.scss';
import { Auth } from "aws-amplify";
import { ENVIRONMENT } from "../../common/constants";

const HeadComponent = (props: any) => {
    const { userName, userEmail, profilePath, onMobileMenuToggle } = props;

    const { Text } = Typography;

    const handleLogout = () => {
        Auth.signOut()
            .then(() => {
                sessionStorage.removeItem('idToken');
                sessionStorage.removeItem('idTokenTime');
                window.location.reload();
                console.log('Session cleared and signed out successfully');
            })
            .catch((error) => {
                console.error('Sign-out error:', error);
            });
    };

    const items = [{
        key: 'avatar', label: (<Menu style={{ padding: '0' }}>
            <Menu.Item className="user-name-label" style={{ background: '#fff', cursor: "text", paddingBottom: '0px !important' }} key="name">
                <Space>
                    <Text type="secondary">{userName}</Text>
                </Space>
            </Menu.Item>
            <Menu.Item className="user-email-label" style={{ background: '#fff', cursor: "text", paddingTop: '0px !important' }} key="email">
                <Space>
                    <Text type="secondary">{userEmail}</Text>
                </Space>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="logout">
                <div
                    onClick={() => handleLogout()}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "start",
                        gap: "8px",
                    }}>
                    <CiLogout style={{ fontSize: "18px", color: 'black' }} />
                    <span>Sign Out</span>
                </div>
            </Menu.Item>
        </Menu>)
    }];

    return (
        <Header className="header-container">
            <Row justify={"space-between"} align="middle" className="header-row">
                <Col className="mobile-menu-toggle">
                    <Button
                        type="text"
                        icon={<MenuOutlined />}
                        onClick={onMobileMenuToggle}
                        className="menu-toggle-btn"
                    />
                </Col>
                <Col className="user-profile-section">
                    <Dropdown rootClassName="header-dropdown" menu={{ items: items, }} trigger={["click"]}>
                        <Avatar size="large" src={`https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${profilePath}`} style={{ background: '#F8CEDBFF' }} />
                    </Dropdown>
                </Col>
            </Row>
        </Header>
    );
};
export default HeadComponent;